<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17.997" viewBox="0 0 17 17.997">
    <g transform="translate(-630.25 -577.753)">
      <g transform="translate(-890 298.048)">
        <path class="a" d="M14.624,18.984V17.656A2.656,2.656,0,0,0,11.968,15H6.656A2.656,2.656,0,0,0,4,17.656v1.328"
              transform="translate(1517 277.968)"/>
        <circle class="a" cx="2.5" cy="2.5" r="2.5" transform="translate(1524 284.952)"/>
      </g>
      <line class="b" x2="6.126" transform="translate(640.374 581.502)"/>
      <line class="b" x1="5.997" transform="translate(643.438 578.503) rotate(90)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "InvitationIcon"
}
</script>

<style scoped>
.a, .b {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-width: 1.5px;
}

.a {
  stroke-linejoin: round;
}
</style>
